// Datos de contacto públicos del sitio. Cambiar aquí actualiza todas las páginas.
export const CONTACT_EMAIL = 'contacto@vekianlabs.com';
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;

export const WHATSAPP_NUMBER = '593962770454';
export const WHATSAPP_DISPLAY = '+593 96 277 0454';
export const whatsappUrl = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
